import React from 'react'
import {Table} from "antd"

const ClubMemberFindTrackWeekly = ({loading, datasource}) => {
    const columns = [
        {
            title: '序号',
            dataIndex: 'rank',
            key: 'rank',
        },
        {
            title: '商品名称',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: '商品价格',
            dataIndex: 'commodity_price',
            key: 'commodity_price',
            render: (text) => {
                return <span>{(text / 100).toFixed(2)}</span>
            },
        },
        {
            title: '数量',
            dataIndex: 'qty',
            key: 'qty',
        },
        {
            title: '消费的俱乐部',
            dataIndex: 'club_name',
            key: 'club_name',
        },
    ]
    return (
        <div>
            <Table
                columns={columns}
                dataSource={datasource}
                loading={loading}
            />
        </div>
    )
}

export default ClubMemberFindTrackWeekly


// WEBPACK FOOTER //
// ./src/containers/ClubMemberList/component/ClubMemberFind/component/ClubMemberFindTrack/component/ClubMemberFindTrackWeekly.js